<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content v-if="currentLocale">
      <!--<b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />-->
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
   
      v-for="localeObj in locales"
      :key="localeObj.code"
      @click="changLocales(localeObj.code)"
    >
      <!--<b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />-->
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import languagesStoreModule from '@/views/languages/languagesStoreModule'
import { ref,onUnmounted } from '@vue/composition-api'
import store from '@/store'
export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
     
      return this.locales.find(l => l.code === this.$i18n.locale)
    },
  },
  methods:{
    changLocales(locale){
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale)

    }
  },
  setup() {
    const locales = ref([]);
    const LANGUAGES_STORE_MODULE_NAME = 'app-languages';
    if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule)
    onUnmounted(() => {
        if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME)
    });
    
    const getLangs = async (fil)=>{
    
      let locale = await store.dispatch('app-languages/fetchData', fil);
     
      if(locale.data.success){

        locales.value = locale.data.data;
       
      }
    }
    let filter = {
      is_active:1,
          
    }
    getLangs(filter);
   
    
   
    /* eslint-disable global-require */
    /*const locales = [
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      {
        locale: 'th',
        img: require('@/assets/images/flags/th.png'),
        name: 'Thai',
      },
      {
        locale: 'cn',
        img: require('@/assets/images/flags/cn.png'),
        name: 'Chinese',
      },
    
    ]*/
    /* eslint-disable global-require */

    return {
      locales,
    }
  },
}
</script>

<style>

</style>
